import React from 'react'
import Card from 'components/index/Card'

export function Breaks({ breaks, breakIsCompleted = false }) {
  return (
    <div className="container">
      <div className="card-row four">
        {breaks &&
          !!breaks.length &&
          breaks.map((brk, i) => {
            return (
              <Card
                key={i}
                brk={brk}
                breakIsCompleted={breakIsCompleted}
                utm_source={`organic`}
                utm_medium={`interstitial`}
                utm_campaign={`dailybreak`}
              />
            )
          })}
      </div>
    </div>
  )
}
